/**
 * Vai trò được chuyển đơn "Đang đóng gói"/"Đã gửi hàng" (BE gác bằng RolesGuard owner/manager riêng).
 * Tách khỏi `parts/orderActionColumn.tsx` để logic thuần (vd `planBatchOrderActions`, TCR-2264)
 * dùng chung mà không kéo theo module UI.
 */
export const FULFILLMENT_ACTION_ROLES: readonly string[] = ['owner', 'manager'];
